    var deliverydata = {
            "fields":  [
                {
    "name": "Adelaide Region",
    "suburbs": [
      { "name": "Adelaide Inner Metro", "post_code": "5000" },
                { "name": "ADELAIDE", "post_code": "5001" },
                { "name": "NORTH ADELAIDE", "post_code": "5006" },
                { "name": "BOWDEN", "post_code": "5007" },
                { "name": "BROMPTON", "post_code": "5007" },
                { "name": "HINDMARSH", "post_code": "5007" },
                { "name": "WELLAND", "post_code": "5007" },
                { "name": "WEST HINDMARSH", "post_code": "5007" },
                { "name": "CROYDON", "post_code": "5008" },
                { "name": "DEVON PARK", "post_code": "5008" },
                { "name": "RENOWN PARK", "post_code": "5008" },
                { "name": "RIDLEYTON", "post_code": "5008" },
                { "name": "WEST CROYDON", "post_code": "5008" },
                { "name": "ALLENBY GARDENS", "post_code": "5009" },
                { "name": "BEVERLEY", "post_code": "5009" },
                { "name": "KILKENNY", "post_code": "5009" },
                { "name": "WOODVILLE", "post_code": "5011" },
                { "name": "WOODVILLE PARK", "post_code": "5011" },
                { "name": "WOODVILLE SOUTH", "post_code": "5011" },
                { "name": "WOODVILLE WEST", "post_code": "5011" },
                { "name": "ATHOL PARK", "post_code": "5012" },
                { "name": "WOODVILLE NORTH", "post_code": "5012" },
                { "name": "PENNINGTON", "post_code": "5013" },
                { "name": "ROSEWATER", "post_code": "5013" },
                { "name": "ROSEWATER EAST", "post_code": "5013" },
                { "name": "ALBERT PARK", "post_code": "5014" },
                { "name": "CHELTENHAM", "post_code": "5014" },
                { "name": "HENDON", "post_code": "5014" },
                { "name": "ROYAL PARK", "post_code": "5014" },
                { "name": "SEMAPHORE PARK", "post_code": "5019" },
                { "name": "WEST LAKES SHORE", "post_code": "5020" },
                { "name": "WEST LAKES", "post_code": "5021" },
                { "name": "GRANGE", "post_code": "5022" },
                { "name": "HENLEY BEACH", "post_code": "5022" },
                { "name": "HENLEY BEACH SOUTH", "post_code": "5022" },
                { "name": "TENNYSON", "post_code": "5022" },
                { "name": "FINDON", "post_code": "5023" },
                { "name": "SEATON", "post_code": "5023" },
                { "name": "FULHAM", "post_code": "5024" },
                { "name": "LOBETHAL", "post_code": "5241" },
                { "name": "CHARLESTON", "post_code": "5244" },
                { "name": "DAWESLEY", "post_code": "5252" },
                { "name": "LITTLEHAMPTON", "post_code": "5250" },
                { "name": "HAHNDORF", "post_code": "5245" },
                { "name": "Balhannah", "post_code": "5242" },
                { "name": "OAKBANK", "post_code": "5243" },
                { "name": "WOODSIDE", "post_code": "5244" },
                { "name": "MOUNT BARKER", "post_code": "5251" },
                { "name": "Adelaide Inner Metro", "post_code": "5000" },
                { "name": "Adelaide BC", "post_code": "5000" },
                { "name": "City West Campus", "post_code": "5000" },
                { "name": "Halifax Street", "post_code": "5000" },
                { "name": "Rundle Mall", "post_code": "5000" },
                { "name": "Station Arcade", "post_code": "5000" },
                { "name": "Sturt Street", "post_code": "5000" },
                { "name": "University Of Adelaide", "post_code": "5005" },
                { "name": "North Adelaide", "post_code": "5006" },
                { "name": "North Adelaide Melbourne St", "post_code": "5006" },
                { "name": "Bowden", "post_code": "5007" },
                { "name": "Brompton", "post_code": "5007" },
                { "name": "Croydon", "post_code": "5008" },
                { "name": "Croydon Park", "post_code": "5008" },
                { "name": "Devon Park", "post_code": "5008" },
                { "name": "Dudley Park", "post_code": "5008" },
                { "name": "Renown Park", "post_code": "5008" },
                { "name": "Ridleyton", "post_code": "5008" },
                { "name": "West Croydon", "post_code": "5008" },
                { "name": "Angle Park", "post_code": "5010" },
                { "name": "Ferryden Park", "post_code": "5010" },
                { "name": "Regency Park", "post_code": "5010" },
                { "name": "Athol Park", "post_code": "5012" },
                { "name": "Mansfield Park", "post_code": "5012" },
                { "name": "Woodville Gardens", "post_code": "5012" },
                { "name": "Woodville North", "post_code": "5012" },
                { "name": "Gillman", "post_code": "5013" },
                { "name": "Ottoway", "post_code": "5013" },
                { "name": "Pennington", "post_code": "5013" },
                { "name": "Rosewater", "post_code": "5013" },
                { "name": "Rosewater East", "post_code": "5013" },
                { "name": "Wingfield", "post_code": "5013" },
                { "name": "Collinswood", "post_code": "5081" },
                { "name": "Gilberton", "post_code": "5081" },
                { "name": "Medindie", "post_code": "5081" },
                { "name": "Medindie Gardens", "post_code": "5081" },
                { "name": "Vale Park", "post_code": "5081" },
                { "name": "Walkerville", "post_code": "5081" },
                { "name": "Fitzroy", "post_code": "5082" },
                { "name": "Ovingham", "post_code": "5082" },
                { "name": "Prospect", "post_code": "5082" },
                { "name": "Prospect East", "post_code": "5082" },
                { "name": "Thorngate", "post_code": "5082" },
                { "name": "Broadview", "post_code": "5083" },
                { "name": "Nailsworth", "post_code": "5083" },
      { "name": "Sefton Park", "post_code": "5083" },
      { "name": "Blair Athol", "post_code": "5084" },
      { "name": "Kilburn", "post_code": "5084" },
      { "name": "Kilburn North", "post_code": "5084" },
      { "name": "Clearview", "post_code": "5085" },
      { "name": "Enfield", "post_code": "5085" },
      { "name": "Enfield Plaza", "post_code": "5085" },
      { "name": "Lightsview", "post_code": "5085" },
      { "name": "Northfield", "post_code": "5085" },
      { "name": "Northgate", "post_code": "5085" },
      { "name": "Gilles Plains", "post_code": "5086" },
      { "name": "Greenacres", "post_code": "5086" },
      { "name": "Hampstead Gardens", "post_code": "5086" },
      { "name": "Hillcrest", "post_code": "5086" },
      { "name": "Manningham", "post_code": "5086" },
      { "name": "Oakden", "post_code": "5086" },
      { "name": "Banksia Park", "post_code": "5091" },
      { "name": "Tea Tree Gully", "post_code": "5091" },
      { "name": "Vista", "post_code": "5091" },
      { "name": "Modbury", "post_code": "5092" },
      { "name": "Modbury Heights", "post_code": "5092" },
      { "name": "Modbury North", "post_code": "5092" },
      { "name": "Modbury North DC", "post_code": "5092" },
      { "name": "Para Vista", "post_code": "5093" },
      { "name": "Valley View", "post_code": "5093" },
      { "name": "Cavan", "post_code": "5094" },
      { "name": "Dry Creek", "post_code": "5094" },
      { "name": "Gepps Cross", "post_code": "5094" },
      { "name": "Mawson Lakes", "post_code": "5095" },
      { "name": "Pooraka", "post_code": "5095" },
      { "name": "Gulfview Heights", "post_code": "5096" },
      { "name": "Para Hills", "post_code": "5096" },
      { "name": "Para Hills West", "post_code": "5096" },
      { "name": "Redwood Park", "post_code": "5097" },
      { "name": "Ridgehaven", "post_code": "5097" },
      { "name": "St Agnes", "post_code": "5097" },
      { "name": "Ingle Farm", "post_code": "5098" },
      { "name": "Walkley Heights", "post_code": "5098" },
      { "name": "Parafield", "post_code": "5106" },
      { "name": "Salisbury South", "post_code": "5106" },
      { "name": "Salisbury South BC", "post_code": "5106" },
      { "name": "Salisbury South DC", "post_code": "5106" },
      { "name": "Green Fields", "post_code": "5107" },
      { "name": "Parafield Gardens", "post_code": "5107" },
      { "name": "Paralowie", "post_code": "5108" },
      { "name": "Salisbury", "post_code": "5108" },
      { "name": "Salisbury Downs", "post_code": "5108" },
      { "name": "Salisbury North", "post_code": "5108" },
      { "name": "Salisbury North Whites Road", "post_code": "5108" },
      { "name": "Brahma Lodge", "post_code": "5109" },
      { "name": "Salisbury East", "post_code": "5109" },
      { "name": "Salisbury East Northbri Ave", "post_code": "5109" },
      { "name": "Salisbury Heights", "post_code": "5109" },
      { "name": "Salisbury Park", "post_code": "5109" },
      { "name": "Salisbury Plain", "post_code": "5109" },
      { "name": "Bolivar", "post_code": "5110" },
      { "name": "Burton", "post_code": "5110" },
      { "name": "Direk", "post_code": "5110" },
      { "name": "Globe Derby Park", "post_code": "5110" },
      { "name": "St Kilda", "post_code": "5110" },
      { "name": "Waterloo Corner", "post_code": "5110" },
      { "name": "Edinburgh", "post_code": "5111" },
      { "name": "Edinburgh RAAF", "post_code": "5111" },
      { "name": "Elizabeth", "post_code": "5112" },
      { "name": "Elizabeth East", "post_code": "5112" },
      { "name": "Elizabeth Grove", "post_code": "5112" },
      { "name": "Elizabeth South", "post_code": "5112" },
      { "name": "Elizabeth Vale", "post_code": "5112" },
      { "name": "Hillbank", "post_code": "5112" },
      { "name": "Davoren Park", "post_code": "5113" },
      { "name": "Davoren Park South", "post_code": "5113" },
      { "name": "Edinburgh North", "post_code": "5113" },
      { "name": "Elizabeth Downs", "post_code": "5113" },
      { "name": "Elizabeth North", "post_code": "5113" },
      { "name": "Elizabeth Park", "post_code": "5113" },
      { "name": "Elizabeth West DC", "post_code": "5113" },
      { "name": "Andrews Farm", "post_code": "5114" },
      { "name": "Blakeview", "post_code": "5114" },
      { "name": "Craigmore", "post_code": "5114" },
      { "name": "Gould Creek", "post_code": "5114" },
      { "name": "Humbug Scrub", "post_code": "5114" },
      { "name": "One Tree Hill", "post_code": "5114" },
      { "name": "Sampson Flat", "post_code": "5114" },
      { "name": "Smithfield", "post_code": "5114" },
      { "name": "Smithfield Plains", "post_code": "5114" },
      { "name": "Smithfield West", "post_code": "5114" },
      { "name": "Uleybury", "post_code": "5114" },
      { "name": "Yattalunga", "post_code": "5114" },
      { "name": "Kudla", "post_code": "5115" },
      { "name": "Munno Para", "post_code": "5115" },
      { "name": "Munno Para Downs", "post_code": "5115" },
      { "name": "Munno Para West", "post_code": "5115" },
      { "name": "Evanston", "post_code": "5116" },
      { "name": "Evanston Gardens", "post_code": "5116" },
      { "name": "Evanston Park", "post_code": "5116" },
      { "name": "Evanston South", "post_code": "5116" },
      { "name": "Hillier", "post_code": "5116" },
      { "name": "Angle Vale", "post_code": "5117" },
      { "name": "Bibaringa", "post_code": "5118" },
      { "name": "Buchfelde", "post_code": "5118" },
      { "name": "Concordia", "post_code": "5118" },
      { "name": "Gawler", "post_code": "5118" },
      { "name": "Gawler Belt", "post_code": "5118" },
      { "name": "Gawler East", "post_code": "5118" },
      { "name": "Gawler River", "post_code": "5118" },
      { "name": "Gawler South", "post_code": "5118" },
      { "name": "Gawler West", "post_code": "5118" },
      { "name": "Hewett", "post_code": "5118" },
      { "name": "Kalbeeba", "post_code": "5118" },
      { "name": "Kangaroo Flat", "post_code": "5118" },
      { "name": "Kingsford", "post_code": "5118" },
      { "name": "Reid", "post_code": "5118" },
      { "name": "Ward Belt", "post_code": "5118" },
      { "name": "Willaston", "post_code": "5118" },
      { "name": "Buckland Park", "post_code": "5120" },
      { "name": "Virginia", "post_code": "5120" },
      { "name": "Eyre", "post_code": "5121" },
      { "name": "Macdonald Park", "post_code": "5121" },
      { "name": "Penfield", "post_code": "5121" },
      { "name": "Penfield Gardens", "post_code": "5121" },
      { "name": "Golden Grove", "post_code": "5125" },
      { "name": "Golden Grove Village", "post_code": "5125" },
      { "name": "Greenwith", "post_code": "5125" },
      { "name": "Fairview Park", "post_code": "5126" },
      { "name": "Surrey Downs", "post_code": "5126" },
      { "name": "Yatala Vale", "post_code": "5126" },
      { "name": "Wynn Vale", "post_code": "5127" },
      { "name": "Houghton", "post_code": "5131" },
      { "name": "Lower Hermitage", "post_code": "5131" },
      { "name": "Upper Hermitage", "post_code": "5131" },
      { "name": "Paracombe", "post_code": "5132" },
      { "name": "Inglewood", "post_code": "5133" },
      { "name": "Clarence Park", "post_code": "5034" },
      { "name": "Goodwood", "post_code": "5034" },
      { "name": "Kings Park", "post_code": "5034" },
      { "name": "Millswood", "post_code": "5034" },
      { "name": "Wayville", "post_code": "5034" },
      { "name": "Glandore", "post_code": "5037" },
      { "name": "Kurralta Park", "post_code": "5037" },
      { "name": "Netley", "post_code": "5037" },
      { "name": "North Plympton", "post_code": "5037" },
      { "name": "Camden Park", "post_code": "5038" },
      { "name": "Plympton", "post_code": "5038" },
      { "name": "Plympton Park", "post_code": "5038" },
      { "name": "South Plympton", "post_code": "5038" },
      { "name": "Clarence Gardens", "post_code": "5039" },
      { "name": "Edwardstown", "post_code": "5039" },
      { "name": "Melrose Park", "post_code": "5039" },
      { "name": "Melrose Park DC", "post_code": "5039" },
      { "name": "Colonel Light Gardens", "post_code": "5041" },
      { "name": "Cumberland Park", "post_code": "5041" },
      { "name": "Daw Park", "post_code": "5041" },
      { "name": "Panorama", "post_code": "5041" },
      { "name": "Westbourne Park", "post_code": "5041" },
      { "name": "Bedford Park", "post_code": "5042" },
      { "name": "Clovelly Park", "post_code": "5042" },
      { "name": "Flinders University", "post_code": "5042" },
      { "name": "Pasadena", "post_code": "5042" },
      { "name": "St Marys", "post_code": "5042" },
      { "name": "Tonsley", "post_code": "5042" },
      { "name": "Ascot Park", "post_code": "5043" },
      { "name": "Marion", "post_code": "5043" },
      { "name": "Mitchell Park", "post_code": "5043" },
      { "name": "Morphettville", "post_code": "5043" },
      { "name": "Park Holme", "post_code": "5043" },
      { "name": "Glengowrie", "post_code": "5044" },
      { "name": "Somerton Park", "post_code": "5044" },
      { "name": "Glenelg", "post_code": "5045" },
      { "name": "Glenelg East", "post_code": "5045" },
      { "name": "Glenelg North", "post_code": "5045" },
      { "name": "Glenelg South", "post_code": "5045" },
      { "name": "Oaklands Park", "post_code": "5046" },
      { "name": "Warradale", "post_code": "5046" },
      { "name": "Warradale North", "post_code": "5046" },
      { "name": "Darlington", "post_code": "5047" },
      { "name": "Seacombe Gardens", "post_code": "5047" },
      { "name": "Seacombe Heights", "post_code": "5047" },
      { "name": "Sturt", "post_code": "5047" },
      { "name": "Brighton", "post_code": "5048" },
      { "name": "Dover Gardens", "post_code": "5048" },
      { "name": "Hove", "post_code": "5048" },
      { "name": "North Brighton", "post_code": "5048" },
      { "name": "South Brighton", "post_code": "5048" },
      { "name": "Kingston Park", "post_code": "5049" },
      { "name": "Marino", "post_code": "5049" },
      { "name": "Seacliff", "post_code": "5049" },
      { "name": "Seacliff Park", "post_code": "5049" },
      { "name": "Seaview Downs", "post_code": "5049" },
      { "name": "Bellevue Heights", "post_code": "5050" },
      { "name": "Eden Hills", "post_code": "5050" },
      { "name": "Blackwood", "post_code": "5051" },
      { "name": "Coromandel Valley", "post_code": "5051" },
      { "name": "Craigburn Farm", "post_code": "5051" },
      { "name": "Hawthorndene", "post_code": "5051" },
      { "name": "Belair", "post_code": "5052" },
      { "name": "Glenalta", "post_code": "5052" },
      { "name": "Hyde Park", "post_code": "5061" },
      { "name": "Malvern", "post_code": "5061" },
      { "name": "Brown Hill Creek", "post_code": "5062" },
      { "name": "Clapham", "post_code": "5062" },
      { "name": "Hawthorn", "post_code": "5062" },
      { "name": "Kingswood", "post_code": "5062" },
      { "name": "Lower Mitcham", "post_code": "5062" },
      { "name": "Lynton", "post_code": "5062" },
      { "name": "Mitcham", "post_code": "5062" },
      { "name": "Mitcham Shopping Centre", "post_code": "5062" },
      { "name": "Netherby", "post_code": "5062" },
      { "name": "Springfield", "post_code": "5062" },
      { "name": "Torrens Park", "post_code": "5062" },
      { "name": "Upper Sturt", "post_code": "5156" },
      { "name": "Ashbourne", "post_code": "5157" },
      { "name": "Bull Creek", "post_code": "5157" },
      { "name": "Cherry Gardens", "post_code": "5157" },
      { "name": "Clarendon", "post_code": "5157" },
      { "name": "Coromandel East", "post_code": "5157" },
      { "name": "Hallett Cove", "post_code": "5158" },
      { "name": "O'Halloran Hill", "post_code": "5158" },
      { "name": "Sheidow Park", "post_code": "5158" },
      { "name": "Trott Park", "post_code": "5158" },
      { "name": "Aberfoyle Park", "post_code": "5159" },
      { "name": "Chandlers Hill", "post_code": "5159" },
      { "name": "Flagstaff Hill", "post_code": "5159" },
      { "name": "Happy Valley", "post_code": "5159" },
      { "name": "Lonsdale", "post_code": "5160" },
      { "name": "Lonsdale DC", "post_code": "5160" },
      { "name": "Old Reynella", "post_code": "5161" },
      { "name": "Reynella", "post_code": "5161" },
      { "name": "Reynella East", "post_code": "5161" },
      { "name": "Morphett Vale", "post_code": "5162" },
      { "name": "Woodcroft", "post_code": "5162" },
      { "name": "Hackham", "post_code": "5163" },
      { "name": "Hackham West", "post_code": "5163" },
      { "name": "Huntfield Heights", "post_code": "5163" },
      { "name": "Onkaparinga Hills", "post_code": "5163" },
      { "name": "Christie Downs", "post_code": "5164" },
      { "name": "Christies Beach", "post_code": "5165" },
      { "name": "Christies Beach North", "post_code": "5165" },
      { "name": "O'Sullivan Beach", "post_code": "5166" },
      { "name": "Port Noarlunga", "post_code": "5167" },
      { "name": "Port Noarlunga South", "post_code": "5167" },
      { "name": "Noarlunga Centre", "post_code": "5168" },
      { "name": "Noarlunga Downs", "post_code": "5168" },
      { "name": "Old Noarlunga", "post_code": "5168" },
      { "name": "Moana", "post_code": "5169" },
      { "name": "Seaford", "post_code": "5169" },
      { "name": "Seaford Heights", "post_code": "5169" },
      { "name": "Seaford Meadows", "post_code": "5169" },
      { "name": "Seaford Rise", "post_code": "5169" },
      { "name": "Maslin Beach", "post_code": "5170" },
      { "name": "Blewitt Springs", "post_code": "5171" },
      { "name": "McLaren Flat", "post_code": "5171" },
      { "name": "McLaren Vale", "post_code": "5171" },
      { "name": "Tatachilla", "post_code": "5171" },
      { "name": "Dingabledinga", "post_code": "5172" },
      { "name": "Willunga", "post_code": "5172" },
      { "name": "Willunga Hill", "post_code": "5172" },
      { "name": "Willunga South", "post_code": "5172" },
      { "name": "Aldinga", "post_code": "5173" },
      { "name": "Aldinga Beach", "post_code": "5173" },
      { "name": "Port Willunga", "post_code": "5173" },
      { "name": "Sellicks Beach", "post_code": "5174" },
      { "name": "Sellicks Hill", "post_code": "5174" },
      { "name": "Unley", "post_code": "5061" },
      { "name": "Unley BC", "post_code": "5061" },
      { "name": "Unley DC", "post_code": "5061" },
      { "name": "Unley Park", "post_code": "5061" },
      { "name": "Eastwood", "post_code": "5063" },
      { "name": "Frewville", "post_code": "5063" },
      { "name": "Fullarton", "post_code": "5063" },
      { "name": "Highgate", "post_code": "5063" },
      { "name": "Parkside", "post_code": "5063" },
      { "name": "Glen Osmond", "post_code": "5064" },
      { "name": "Glenunga", "post_code": "5064" },
      { "name": "Mount Osmond", "post_code": "5064" },
      { "name": "Myrtle Bank", "post_code": "5064" },
      { "name": "St Georges", "post_code": "5064" },
      { "name": "Urrbrae", "post_code": "5064" },
      { "name": "Dulwich", "post_code": "5065" },
      { "name": "Glenside", "post_code": "5065" },
      { "name": "Linden Park", "post_code": "5065" },
      { "name": "Toorak Gardens", "post_code": "5065" },
      { "name": "Tusmore", "post_code": "5065" },
      { "name": "Beaumont", "post_code": "5066" },
      { "name": "Burnside", "post_code": "5066" },
      { "name": "Erindale", "post_code": "5066" },
      { "name": "Hazelwood Park", "post_code": "5066" },
      { "name": "Stonyfell", "post_code": "5066" },
      { "name": "Waterfall Gully", "post_code": "5066" },
      { "name": "Wattle Park", "post_code": "5066" },
      { "name": "Beulah Park", "post_code": "5067" },
      { "name": "Kent Town", "post_code": "5067" },
      { "name": "Norwood", "post_code": "5067" },
      { "name": "Norwood South", "post_code": "5067" },
      { "name": "Rose Park", "post_code": "5067" },
      { "name": "Heathpool", "post_code": "5068" },
      { "name": "Kensington", "post_code": "5068" },
      { "name": "Kensington Gardens", "post_code": "5068" },
      { "name": "Kensington Park", "post_code": "5068" },
      { "name": "Leabrook", "post_code": "5068" },
      { "name": "Marryatville", "post_code": "5068" },
      { "name": "St Morris", "post_code": "5068" },
      { "name": "Trinity Gardens", "post_code": "5068" },
      { "name": "College Park", "post_code": "5069" },
      { "name": "Evandale", "post_code": "5069" },
      { "name": "Hackney", "post_code": "5069" },
      { "name": "Maylands", "post_code": "5069" },
      { "name": "St Peters", "post_code": "5069" },
      { "name": "Stepney", "post_code": "5069" },
      { "name": "Felixstow", "post_code": "5070" },
      { "name": "Firle", "post_code": "5070" },
      { "name": "Glynde", "post_code": "5070" },
      { "name": "Glynde Plaza", "post_code": "5070" },
      { "name": "Joslin", "post_code": "5070" },
      { "name": "Marden", "post_code": "5070" },
      { "name": "Payneham", "post_code": "5070" },
      { "name": "Payneham South", "post_code": "5070" },
      { "name": "Royston Park", "post_code": "5070" },
      { "name": "Kent Town DC", "post_code": "5071" },
      { "name": "Auldana", "post_code": "5072" },
      { "name": "Magill", "post_code": "5072" },
      { "name": "Magill North", "post_code": "5072" },
      { "name": "Magill South", "post_code": "5072" },
      { "name": "Rosslyn Park", "post_code": "5072" },
      { "name": "Skye", "post_code": "5072" },
      { "name": "Teringie", "post_code": "5072" },
      { "name": "Woodforde", "post_code": "5072" },
      { "name": "Hectorville", "post_code": "5073" },
      { "name": "Rostrevor", "post_code": "5073" },
      { "name": "Tranmere", "post_code": "5073" },
      { "name": "Tranmere North", "post_code": "5073" },
      { "name": "Campbelltown", "post_code": "5074" },
      { "name": "Newton", "post_code": "5074" },
      { "name": "Dernancourt", "post_code": "5075" },
      { "name": "Paradise", "post_code": "5075" },
      { "name": "Athelstone", "post_code": "5076" },
      { "name": "Castambul", "post_code": "5076" },
      { "name": "Klemzig", "post_code": "5087" },
      { "name": "Windsor Gardens", "post_code": "5087" },
      { "name": "Holden Hill", "post_code": "5088" },
      { "name": "Highbury", "post_code": "5089" },
      { "name": "Hope Valley", "post_code": "5090" },
      { "name": "Cherryville", "post_code": "5134" },
      { "name": "Montacute", "post_code": "5134" },
      { "name": "Norton Summit", "post_code": "5136" },
      { "name": "Ashton", "post_code": "5137" },
      { "name": "Marble Hill", "post_code": "5137" },
      { "name": "Basket Range", "post_code": "5138" },
      { "name": "Forest Range", "post_code": "5139" },
      { "name": "Greenhill", "post_code": "5140" },
      { "name": "Horsnell Gully", "post_code": "5141" },
      { "name": "Summertown", "post_code": "5141" },
      { "name": "Uraidla", "post_code": "5142" },
      { "name": "Carey Gully", "post_code": "5144" },
      { "name": "Leawood Gardens", "post_code": "5150" },
      { "name": "Piccadilly", "post_code": "5151" },
      { "name": "Cleland", "post_code": "5152" },
      { "name": "Crafers", "post_code": "5152" },
      { "name": "Crafers West", "post_code": "5152" },
      { "name": "Stirling", "post_code": "5152" },
      { "name": "Mylor", "post_code": "5153" },
      { "name": "Scott Creek", "post_code": "5153" },
      { "name": "Aldgate", "post_code": "5154" },
      { "name": "Bridgewater", "post_code": "5155" },
      { "name": "Mount George", "post_code": "5155" },
      { "name": "Hindmarsh", "post_code": "5007" },
      { "name": "Welland", "post_code": "5007" },
      { "name": "West Hindmarsh", "post_code": "5007" },
      { "name": "Beverley", "post_code": "5009" },
      { "name": "Woodville", "post_code": "5011" },
      { "name": "Albert Park", "post_code": "5014" },
      { "name": "Birkenhead", "post_code": "5015" },
      { "name": "Largs Bay", "post_code": "5016" },
      { "name": "Peterhead", "post_code": "5016" },
      { "name": "Osborne", "post_code": "5017" },
      { "name": "Taperoo", "post_code": "5017" },
      { "name": "North Haven", "post_code": "5018" },
      { "name": "Outer Harbor", "post_code": "5018" },
      { "name": "Exeter", "post_code": "5019" },
      { "name": "Semaphore", "post_code": "5019" },
      { "name": "Semaphore Park", "post_code": "5019" },
      { "name": "Semaphore South", "post_code": "5019" },
      { "name": "West Lakes Shore", "post_code": "5020" },
      { "name": "West Lakes", "post_code": "5021" },
      { "name": "Grange", "post_code": "5022" },
      { "name": "Henley Beach", "post_code": "5022" },
      { "name": "Tennyson", "post_code": "5022" },
      { "name": "Findon", "post_code": "5023" },
      { "name": "Seaton", "post_code": "5023" },
      { "name": "Fulham", "post_code": "5024" },
      { "name": "Fulham Gardens", "post_code": "5024" },
      { "name": "West Beach", "post_code": "5024" },
      { "name": "Flinders Park", "post_code": "5025" },
      { "name": "Mile End", "post_code": "5031" },
      { "name": "Thebarton", "post_code": "5031" },
      { "name": "Torrensville", "post_code": "5031" },
      { "name": "Torrensville Plaza", "post_code": "5031" },
      { "name": "Brooklyn Park", "post_code": "5032" },
      { "name": "Lockleys", "post_code": "5032" },
      { "name": "Underdale", "post_code": "5032" },
      { "name": "Cowandilla", "post_code": "5033" },
      { "name": "Ashford", "post_code": "5035" },
      { "name": "Novar Gardens", "post_code": "5040" },
      { "name": "Lobethal", "post_code": "5241" },
      { "name": "Charleston", "post_code": "5244" },
      { "name": "Nairne", "post_code": "5252" },
      { "name": "Littlehampleton", "post_code": "5250" },
      { "name": "Hahndorf", "post_code": "5245" },
      { "name": "Balhannah", "post_code": "5242" },
      { "name": "Oakbank", "post_code": "5243" },
      { "name": "Woodside", "post_code": "5244" },
      { "name": "Mountbarker", "post_code": "5251" },
      { "name": "Adelaide Airport", "post_code": "5950" },
      { "name": "Lenswood", "post_code": "5240" },
      { "name": "Kuitpo", "post_code": "5201" },
      { "name": "Kuitpo", "post_code": "5232" },
      { "name": "Chain Of Ponds", "post_code": "5231" },
      { "name": "Forreston", "post_code": "5233" },
      { "name": "Petwood", "post_code": "5254" },
      { "name": "Birdwood", "post_code": "5234" },
      { "name": "Barossa Goldfields", "post_code": "5351" },
      { "name": "Mount Compass", "post_code": "5210" },
      { "name": "Tungkillo", "post_code": "5236" },
      { "name": "Angas Plains", "post_code": "5255" },
      { "name": "Avon", "post_code": "5501" },
      { "name": "Altona", "post_code": "5351" },
      { "name": "Altona", "post_code": "5351" }
                    ]
                }
            ]
        };

// ---- Suburb name lookup (used to label the map) ----
function buildPostcodeSuburb(data){
  var map = {};
  data.fields.forEach(function(f){
    f.suburbs.forEach(function(s){ if(!map[s.post_code]) map[s.post_code] = s.name; });
  });
  return map;
}
var postcodeSuburb = buildPostcodeSuburb(deliverydata);

// ---- Delivery zones: fee + minimum order by postcode ----
var deliveryZones = [
  { id: 1, name: 'Metro Adelaide', fee: '16.00', min: '60.00', postcodes: ['5000','5005','5006','5007','5008','5009','5010','5011','5012','5013','5014','5015','5016','5017','5018','5019','5020','5021','5022','5023','5024','5025','5031','5032','5033','5034','5035','5036','5037','5038','5039','5040','5041','5042','5043','5044','5045','5046','5047','5048','5049','5050','5051','5052','5061','5062','5063','5064','5065','5066','5067','5068','5069','5070','5071','5072','5073','5074','5075','5076','5081','5082','5083','5084','5085','5086','5087','5088','5089','5090','5091','5092','5093','5094','5095','5096','5097','5098','5106','5107','5108','5109','5110','5111','5112','5113','5114','5115','5150','5151','5152','5158','5159','5160','5161','5162','5163','5164','5165','5166','5167','5168','5169'] },
  { id: 2, name: 'Outer Metro & Hills Fringe', fee: '20.00', min: '80.00', postcodes: ['5116','5117','5118','5119','5120','5121','5125','5126','5127','5153','5154','5155','5156','5157','5170','5171','5172','5173','5174','5240','5241','5242','5243','5244','5245','5250','5251','5252','5350','5400','5501'] },
  { id: 3, name: 'Hills, Fleurieu & Barossa', fee: '25.00', min: '100.00', postcodes: ['5201','5202','5203','5204','5210','5231','5232','5233','5234','5235','5253','5254','5255','5351','5352','5353','5354','5355','5356','5360','5371','5372','5373','5460','5502'] }
];
var postcodeZone = {};
deliveryZones.forEach(function(z){ z.postcodes.forEach(function(pc){ postcodeZone[pc] = z; }); });
function findZone(pc){ return postcodeZone[pc] || null; }

function titleCase(str){ return String(str).toLowerCase().replace(/\b\w/g, function(c){ return c.toUpperCase(); }); }
function setText(id, val){ var el = document.getElementById(id); if(el) el.textContent = val; }

// Pan/zoom the embedded map to a location (no API key required)
function moveMap(query){
  var iframe = document.getElementById('dlv2-map');
  if(!iframe) return;
  iframe.src = 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&z=13&output=embed';
}

(function(){
  var form = document.getElementById('pincode-form');
  if(!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var pc = (document.getElementById('pinInput').value || '').trim();
    var success = document.getElementById('dlvv--chk__success-messagex');
    var fail = document.getElementById('dlvvv-ssohnooo');
    if(!success || !fail) return;

    var zone = findZone(pc);
    if(zone){
      var suburb = postcodeSuburb[pc] ? titleCase(postcodeSuburb[pc]) : pc;
      setText('dlv2-yes-text', 'Great news \u2014 we deliver to ' + suburb + ' (' + pc + ')!');
      setText('dlv2-zone', 'Zone ' + zone.id + ' \u00b7 ' + zone.name);
      var feeEl = success.querySelector('.price-con');
      if(feeEl) feeEl.textContent = zone.fee;
      setText('dlv2-min', zone.min);
      moveMap(suburb + ' SA ' + pc + ' Australia');
      success.classList.add('REsultTrue');
      fail.classList.remove('REsultfalse');
    } else {
      setText('dlv2-no-pc', pc || 'your postcode');
      if(/^\d{4}$/.test(pc)) moveMap(pc + ' South Australia Australia');
      success.classList.remove('REsultTrue');
      fail.classList.add('REsultfalse');
    }
  });
})();
